
 export const getType = ( store, alias) => { 
    return store.data.data.find(custom => custom.alias === alias);
 }
 export const getParentMenu = ( data, alias) => { 
   return data.filter(custom => custom.parentDatabaseId === alias);
}
 export const getMenu = ( data, alias) => { 
   return data.nodes.find(custom => custom.name === alias);
}
export const getCurrentYear = () =>{
   const d = new Date();
   return d.getFullYear();
}
export const filterArray = (storeContent, field) =>{
   return storeContent.data.data.filter(custom => custom.alias === field); 
}
export const filterProviders = (store, type) => { 
      return store.location.providers.filter(custom => custom.type === type);
 
}
export const filterSingleProv = (store, type) => { 
      return store.data.providers.filter(custom => custom.type === type);
}
export const filterStores = (data, brand) => {
   return data.filter(item => item.name == brand);
}
export const removeDecimals = (num) => { 
    let new_num = parseInt(num)
    return new_num.toLocaleString("en-US");
}

export const filterMenu = (data, type) =>{
   return data.nodes.filter(custom => custom.slug === type);
}
export const formatDate = (date ) => {
   const dateStr = date;
   const formattedDate = dateStr.substring(0, 10);
   return formattedDate;
}
export const excerptText = (text) =>{
   let subText = text;
   if(text !== null){
      const sizeText = text.length;
      if(sizeText > 200){
         subText = (text.substring(0, 200))+"...";
      }

   }
   return subText;
}

export const upperCase = (str) => {
   let splitStr = str.toLowerCase().split(' ');
   for (let i = 0; i < splitStr.length; i++) {
       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
   }
   return splitStr.join(' '); 
}
export const formatPhoneNumber = (str) => {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');
  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  };
  return str
} 
export const formatPhoneCCCS = (phoneNumber) => {
   // Remove the +1 and any spaces or dashes
   let cleaned = phoneNumber.replace('+1', '').replace(/[-\s]/g, '');
 
   // Extract the area code and the rest of the number
   let areaCode = cleaned.substring(0, 3);
   let centralOfficeCode = cleaned.substring(3, 6);
   let lineNumber = cleaned.substring(6, 10);
 
   // Format the number
   return `(${areaCode})-${centralOfficeCode}-${lineNumber}`;
 }
export const InternationalNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/[^\d]/g, '');
  const areaCode = cleaned.substring(0, 3);
  const localNumber = cleaned.substring(3);
  const formattedNumber = `(${areaCode}) ${localNumber.substring(0, 3)}-${localNumber.substring(3)}`;
  return formattedNumber;
}
export const formatHour12 = (ctime) =>{
   const timeString = ctime;
   // Prepend any date. Use your birthday.
   const timeString12hr = new Date('2022-01-01T' + timeString + 'Z')
   .toLocaleTimeString('en-US',
       {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'}
   );
   return timeString12hr
}

export const cardsData = () => {
  const info = [{
         "icon"      : "https://localstoresdev.wpengine.com/wp-content/uploads/2022/12/payroll.svg",
         "title"     : "Payroll Advances",
         "paragraph" : "Get cash quickly and easily to help hold you over until your next payday.",
         "link"      : "",
         "explore"   : "",
      },{
         "icon"      : "https://localstoresdev.wpengine.com/wp-content/uploads/2022/12/express.svg",
         "title"     : "Express Loans",
         "paragraph" : "Use your vehicle registration to receive cash. Payment due at your next payday.",
         "link"      : "",
         "explore"   : "",
      },{
         "icon"      : "https://localstoresdev.wpengine.com/wp-content/uploads/2022/12/installment.svg",
         "title"     : "Installment Loans",
         "paragraph" : "Use your vehicle registration to receive cash. Payment due at your next payday.",
         "link"      : "",
         "explore"   : "",
      },{
         "icon"      : "https://localstoresdev.wpengine.com/wp-content/uploads/2022/12/title.svg",
         "title"     : "Title Loans",
         "paragraph" : "Use your car, motorcycle, or RV title for cash. Keep using your vehicle, too.",
         "link"      : "",
         "explore"   : "",
      },
   ]
   return info
}

export const StoreL = () => {
   const info = {
          "title"         : "Over 800 locations, Find one Near you",
          "background"    : "https://cacheckcashdev.wpengine.com/wp-content/plugins/cic-moment-feed/img/california.jpg",
          "paragraph"     : "With locations in over 20 states, finding a store nearby is quick and easy. Find your closest store location by entering your ZIP code below.",
          "button"        : "Search",
          "button_aria"   : "Click here to search for Check Into Cash Stores in your ZIP code",
          "button2"       : "Apply Now",
          "button2_link"  : `${process.env.GATSBY_APPLY}`,
          "button2_aria"  : "Click here to apply now online for a Check Into Cash loan",
       }
    return info
 }
 
export const LocationsArray = () => {
   const info = [
      {
         "name"   : "CA",
         "link"   : "ca/",
      },
   ]
    return info
 }
 export const pageName = () => {
    let link = null
    if (typeof window !== `undefined`){
        link =  window.location.pathname; 
    }
    if(link !== null){
       const bread_reverse = link.split('/');
       return bread_reverse;
    }
 }
 export const statesList = () => { 
   const statesUrls = [
      { state:    'AL', url:    'alabama' ,          full_name : 'Alabama'},
      { state:    'AK', url:    'alaska' ,           full_name : 'Alaska'},
      { state:    'AZ', url:    'arizona' ,          full_name : 'Arizona'},
      { state:    'AR', url:    'arkansas' ,         full_name : 'Arkansas'},
      { state:    'CA', url:    'california' ,       full_name : 'California'},
      { state:    'CO', url:    'colorado' ,         full_name : 'Colorado'},
      { state:    'CT', url:    'connecticut' ,      full_name : 'Connecticut'},
      { state:    'DE', url:    'delaware' ,         full_name : 'Delaware'},
      { state:    'FL', url:    'florida' ,          full_name : 'Florida'},
      { state:    'GA', url:    'georgia' ,          full_name : 'Georgia'},
      { state:    'HI', url:    'hawaii' ,           full_name : 'Hawaii'},
      { state:    'ID', url:    'idaho' ,            full_name : 'Idaho'},
      { state:    'IL', url:    'illinois' ,         full_name : 'Illinois'},
      { state:    'IN', url:    'indiana' ,          full_name : 'Indiana'},
      { state:    'IA', url:    'iowa' ,             full_name : 'Iowa'},
      { state:    'KS', url:    'kansas' ,           full_name : 'Kansas'},
      { state:    'KY', url:    'kentucky' ,         full_name : 'Kentucky'},
      { state:    'LA', url:    'louisiana' ,        full_name : 'Louisiana'},
      { state:    'ME', url:    'maine' ,            full_name : 'Maine'},
      { state:    'MD', url:    'maryland' ,         full_name : 'Maryland'},
      { state:    'MA', url:    'massachusetts' ,    full_name : 'Massachusetts'},
      { state:    'MI', url:    'michigan' ,         full_name : 'Michigan'},
      { state:    'MN', url:    'minnesota' ,        full_name : 'Minnesota'},
      { state:    'MS', url:    'mississippi' ,      full_name : 'Mississippi'},
      { state:    'MO', url:    'missouri' ,         full_name : 'Missouri'},
      { state:    'MT', url:    'montana' ,          full_name : 'Montana'},
      { state:    'NE', url:    'nebraska' ,         full_name : 'Nebraska'},
      { state:    'NV', url:    'nevada' ,           full_name : 'Nevada'},
      { state:    'NH', url:    'new-hampshire' ,    full_name : 'New Hampshire'},
      { state:    'NJ', url:    'new-jersey' ,       full_name : 'New Jersey'},
      { state:    'NM', url:    'new mexico' ,       full_name : 'New Mexico'},
      { state:    'NY', url:    'new-york' ,         full_name : 'New York'},
      { state:    'NC', url:    'north-carolina' ,   full_name : 'North Carolina'},
      { state:    'ND', url:    'north dakota' ,     full_name : 'North Dakota'},
      { state:    'OH', url:    'ohio' ,             full_name : 'Ohio'},
      { state:    'OK', url:    'oklahoma' ,         full_name : 'Oklahoma'},
      { state:    'OR', url:    'oregon' ,           full_name : 'Oregon'},
      { state:    'PA', url:    'pennsylvania' ,     full_name : 'Pennsylvania'},
      { state:    'RI', url:    'rhode island' ,     full_name : 'Rhode Island'},
      { state:    'SC', url:    'south carolina' ,   full_name : 'South Carolina'},
      { state:    'SD', url:    'south-dakota' ,     full_name : 'South Dakota'},
      { state:    'TN', url:    'tennessee' ,        full_name : 'Tennessee'},
      { state:    'TX', url:    'texas' ,            full_name : 'Texas'},
      { state:    'UT', url:    'utah' ,             full_name : 'Utah'},
      { state:    'VT', url:    'vermont' ,          full_name : 'Vermont'},
      { state:    'VA', url:    'virginia' ,         full_name : 'Virginia'},
      { state:    'WA', url:    'washington' ,       full_name : 'Washington'},
      { state:    'WV', url:    'west-virginia' ,    full_name : 'West Virginia'},
      { state:    'WI', url:    'wisconsin' ,        full_name : 'Wisconsin'},
      { state:    'WY', url:    'wyoming' ,          full_name : 'Wyoming'},
  ];
   return statesUrls;
}

export const getBrands = () => {
   const brands = [{
           "title"      : "Check Into Cash",
           "link"       : "https://checkintocash.com/",
           "localLink"  : "https://local.checkintocash.com/",
           "dev"        : "https://localstoresdev.wpengine.com/",
        },{
           "title"      : "Easy Money",
           "link"       : "https://goeasymoney.cash/",
           "localLink"  : "https://local.goeasymoney.cash/",
           "dev"        : "",
        },{
           "title"      : "CheckSmart",
           "link"       : "https://checksmart.brandswapdev.wpengine.com/",
           "localLink"  : "https://checksmart.localstoresdev.wpengine.com/",
           "dev"        : "",
        },{
           "title"      : "California Check Cashing",
           "link"       : "https://cacheck.brandswapdev.wpengine.com/",
           "localLink"  : "https://california.localstoresdev.wpengine.com",
           "dev"        : "https://californiacc-demo.netlify.app/",
        },{
           "title"      : "Cash 1",
           "link"       : "https://cash1.brandswapdev.wpengine.com/",
           "localLink"  : "https://cash1.localstoresdev.wpengine.com",
           "dev"        : "",
        },{
           "title"      : "Cash&Go",
           "link"       : "https://cashandgo.brandswapdev.wpengine.com/",
           "localLink"  : "https://cashgo.localstoresdev.wpengine.com",
           "dev"        : "",
        },{
           "title"      : "First Virginia",
           "link"       : "https://firstvirginia.brandswapdev.wpengine.com/",
           "localLink"  : "https://firstvirginia.localstoresdev.wpengine.com",
           "dev"        : "",
        },{
           "title"      : "Speedy Cash",
           "link"       : "https://www.speedycash.com/",
           "localLink"  : "https://www.speedycash.com/find-a-store/",
           "dev"        : "",
        },
    ]
    return brands
 }
 export const sitelinks = () => {
   const links = [
      {
        page_name: "Blog",
        link: "/blog/"
      },
      {
         page_name: "California Check Cashing Stores ",
         link: "/cash-my-check/"
       },
       {
         page_name: "Payday Loans",
         link: "/payday-loans/"
       },
       {
         page_name: "California",
         link: "/california/"
       },
       {
         page_name: "Cash My Check",
         link: "/cash-my-check/"
       },
       {
         page_name: "Pay My Bills",
         link: "/pay-my-bills/"
       },
       {
         page_name: "Western Union® Money Transfer",
         link: "/wu-money-transfer/"
       },
       {
         page_name: "Western Union® Money Orders",
         link: "/wu-money-orders/"
       },
       {
         page_name: "Tax Preparation Help",
         link: "/tax-prep/"
       },
       {
         page_name: "Green Dot™ VISA® Debit Card",
         link: "/greendot/"
       },
       {
         page_name: "About Us",
         link: "/about-us/"
       },
       {
         page_name: "Contact Us",
         link: "/contact-us/"
       },
       {
         page_name: "Services",
         link: "/financial-services/"
       },
       {
         page_name: "California Privacy Policy",
         link: "https://disclosures.ccffamilyofbrands.com/ccf/ca-privacy-policy/"
       },
       {
         page_name: "Sitemap",
         link: "/sitemap/"
       },
       {
         page_name: "Site to Store",
         link: "/site-to-store/"
       },
       {
         page_name: "FAQs",
         link: "/faqs/"
       },
       {
         page_name: "Local California Stores",
         link: "/us/"
       },
   ]
   return links
 }
 export const returnUrl = (brand, city, address, StoreUrl = "") => {
     let url = ""; 
     switch (brand) {
         // case "California Check Cashing Stores":
         //     const link = (city.replace(/ /g, '-')).toLowerCase();
         //     const link2 = (address.replace(/ /g, '-')).toLowerCase();
         //     url = `https://californiacc-dev.netlify.app/us/ca/${link}/${link2}/`;
         // break;
         default:
             (StoreUrl !== null ) ? url = StoreUrl : url = "#";
         break;
     }
     return url;
 }

 export const returnImg = (brand, storeimg = "") => {
     let img = "";
     switch (brand) {
         case "California Check Cashing Stores":
               if(storeimg === ""){
                  img = "https://cacheckcashdev.wpengine.com/wp-content/plugins/cic-moment-feed/img/california.jpg";
               }
                 img= storeimg;
             break;
         case "CheckSmart":
                 img = "https://checksmartdev.wpengine.com/wp-content/uploads/2022/12/checksmartstore.jpg";
             break;
         default:
             img =  "https://localstoresprd.wpenginepowered.com/wp-content/uploads/moment-feed/store.webp";
             break;
     }
     return img;
 }

 export const ExistSuperscript = (sentence, tag = "h1", classN="") => {
   if (sentence.includes("®")) {
      const newText = sentence.replace(/®/g, "<sup>®</sup>");
      const title = `<${tag} class="${classN}">`+newText+`</${tag}>`
      return title;
    }
    else{
      return sentence;
    }
 }

 export const GetWaves = () => {
   const colors = ["bg-wave-blue","bg-wave-green", "bg-wave-pink", "bg-wave-yellow"];
   return colors;
 }
 export const GetWavesBlog = () => {
   const colors = ["wav-bg-wave-pink", "wav-bg-wave-yellow", "wav-bg-wave-blue","wav-bg-wave-green"];
   return colors;
 }
export const FormatCatUrl = (url) => {
   const new_url = url.replace(/_/g, "-");
   return new_url;
}
 export const NameTest = (name) => {
   let prov_name = name.trim();
   let full_name = "";
   if(prov_name === ""){
       full_name= "Anonymous";
   }
   else{
       const words = prov_name.split(' ');
       full_name = words[0];
   }
   return full_name;
 }

 export const formatDateAndTime = (date, time) => {
     // Format the date
     let formattedDate = date.replace(/-/g, "/"); // Converts "2024-10-31" to "2024/10/31"
 
     // Convert time to 24-hour format if needed
     let [timePart, meridian] = time.split(/(AM|PM)/i);
     let [hours, minutes] = timePart.trim().split(":").map(Number);
 
     if (meridian.toUpperCase() === "PM" && hours < 12) {
         hours += 12;
     } else if (meridian.toUpperCase() === "AM" && hours === 12) {
         hours = 0;
     }
 
     // Pad hours and minutes if needed to ensure two-digit format
     let formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
 
     // Combine date and time
     return `${formattedDate} ${formattedTime}`;
 }
 export const getUTCDateTime = (selectedDate, selectedTime) =>{
     // 1. Parse the selected time (e.g., "11:00 AM")
     const [time, period] = selectedTime.split(" ");
     let [hour, minute] = time.split(":").map(Number);
 
     // Adjust for AM/PM format
     if (period === "PM" && hour !== 12) hour += 12;
     if (period === "AM" && hour === 12) hour = 0;
 
     // 2. Create a Date object with the selected local time
     const localDateTime = new Date(`${selectedDate}T${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:00`);
 
     // 3. Convert to UTC by adjusting for the timezone offset
     const utcDateTime = new Date(localDateTime.getTime() + localDateTime.getTimezoneOffset() * 60000);
 
     // 4. Format UTC date and time as "YYYY-MM-DD HH:MM"
     const formattedDate = `${utcDateTime.getFullYear()}-${(utcDateTime.getMonth() + 1).toString().padStart(2, '0')}-${utcDateTime.getDate().toString().padStart(2, '0')}`;
     const formattedHour = utcDateTime.getHours().toString().padStart(2, '0');
     const formattedMinute = utcDateTime.getMinutes().toString().padStart(2, '0');
 
     // 5. Return UTC and the original local time for reference
     return {
         utcTime: `${formattedDate} ${formattedHour}:${formattedMinute}`,
         localTime: `${selectedDate} ${selectedTime}`
     };
 }